import styled from 'styled-components';

export const StyledPlaySimpleSubProduct = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  .sub-product {
    &--ios13 {
      margin-right: 4px;
      margin-bottom: 8px;
    }

    &--image {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #8a8a8a;
      position: absolute;
      z-index: 1;

      .image {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &--amount {
      display: flex;
      align-items: center;
      padding: 5px 10px 5px 25px;
      background: #8a8a8a;
      width: 74px;
      text-align: center;
      box-sizing: border-box;
      max-height: 24px;
      justify-content: center;
      border-radius: 28px;

      &__price {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }
`;
